'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style = require('styled-jsx/style');

var _style2 = _interopRequireDefault(_style);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _base = require('../base');

var _base2 = _interopRequireDefault(_base);

var _defaultProps = require('../default-props');

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Elastic = function (_React$Component) {
	(0, _inherits3.default)(Elastic, _React$Component);

	function Elastic() {
		(0, _classCallCheck3.default)(this, Elastic);
		return (0, _possibleConstructorReturn3.default)(this, (Elastic.__proto__ || Object.getPrototypeOf(Elastic)).apply(this, arguments));
	}

	(0, _createClass3.default)(Elastic, [{
		key: 'render',
		value: function render() {
			var _props = this.props,
			    lineHeight = _props.lineHeight,
			    lineSpacing = _props.lineSpacing;


			var yOffset = lineSpacing + lineHeight;

			return _react2.default.createElement(
				_base2.default,
				(0, _extends3.default)({ className: 'BurgerElastic' }, this.props),
				_react2.default.createElement(_style2.default, {
					styleId: '2514207425',
					css: '.BurgerElastic .BurgerInner{top:' + lineHeight / 2 + 'px;-webkit-transition-duration:0.275s;transition-duration:0.275s;-webkit-transition-timing-function:cubic-bezier(0.68,-0.55,0.265,1.55);transition-timing-function:cubic-bezier(0.68,-0.55,0.265,1.55);}.BurgerElastic .BurgerInner:before{top:' + yOffset + 'px;-webkit-transition:opacity 0.125s 0.275s ease;transition:opacity 0.125s 0.275s ease;}.BurgerElastic .BurgerInner:after{top:' + yOffset * 2 + 'px;-webkit-transition:-webkit-transform 0.275s cubic-bezier(0.68,-0.55,0.265,1.55);-webkit-transition:transform 0.275s cubic-bezier(0.68,-0.55,0.265,1.55);transition:transform 0.275s cubic-bezier(0.68,-0.55,0.265,1.55);}.BurgerElastic.BurgerActive .BurgerInner{-webkit-transform:translate3d(0,' + yOffset + 'px,0) rotate(135deg);-ms-transform:translate3d(0,' + yOffset + 'px,0) rotate(135deg);transform:translate3d(0,' + yOffset + 'px,0) rotate(135deg);-webkit-transition-delay:0.075s;transition-delay:0.075s;}.BurgerElastic.BurgerActive .BurgerInner:before{-webkit-transition-delay:0s;transition-delay:0s;opacity:0;}.BurgerElastic.BurgerActive .BurgerInner:after{-webkit-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-270deg);-ms-transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-270deg);transform:translate3d(0,' + yOffset * -2 + 'px,0) rotate(-270deg);-webkit-transition-delay:0.075s;transition-delay:0.075s;}\n/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */\n/*@ sourceURL=../../src/types/elastic.js */',
					dynamic: [lineHeight / 2, yOffset, yOffset * 2, yOffset, yOffset * -2]
				})
			);
		}
	}]);
	return Elastic;
}(_react2.default.Component);

exports.default = Elastic;


Elastic.defaultProps = _defaultProps2.default;
module.exports = exports['default'];
//# sourceMappingURL=elastic.js.map